import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import PageHeader from '../components/shared/PageHeader';
import ReminderSettings from '../components/shared/ReminderSettings';
import { STEP_TYPES, SURVEY_STEP_TYPES } from '../components/timeoff/reminderSchedule';

const approvalReminders = {
  scope: 'vacation_approval_reminders',
  title: 'Approval Reminder Emails',
  description: 'Reminder emails sent to approvers while a time off request is waiting for approval.',
  stepTypes: STEP_TYPES,
  defaults: [{ type: 'immediate' }],
  payload: { trigger: 'approval_created', requestType: 'vacation' },
};

const surveyReminders = {
  scope: 'survey_reminders',
  title: 'Survey Reminder Emails',
  description: 'Reminder emails sent to assigned recipients who have not submitted their survey responses.',
  stepTypes: SURVEY_STEP_TYPES,
  defaults: [{ type: 'days_before_close', days: 3 }, { type: 'days_before_close', days: 0 }],
  allowEmpty: true,
  survey: true,
};

export default function NotificationsConfigurationPage() {
  const auth = useAuth();
  const isAdmin = auth.isAdmin();

  return (
    <div className="bdc-page">
      <PageHeader
        crumbs={[
          { label: 'Home', to: '/' },
          { label: 'Admin', to: '/admin' },
          { label: 'Configuration', to: '/admin/configuration' },
          { label: 'Notifications' },
        ]}
        icon="bi-envelope"
        title="Notifications"
      />
      {isAdmin || auth.hasPermission('manage_roles') ? <ReminderSettings definition={approvalReminders} /> : null}
      {isAdmin || auth.hasPermission('create_surveys') ? <ReminderSettings definition={surveyReminders} /> : null}
    </div>
  );
}